module.exports = __webpack_public_path__ + "img/bot_bdsh2.4b499308.png";